import { fetch } from "../../../appContainer";
import {
  GET_ENTERPRISE_LOGO_FAIL,
  GET_ENTERPRISE_LOGO_IN_PROGRESS,
  GET_ENTERPRISE_LOGO_SUCCESS,
  UPDATE_ENTERPRISE_FAIL,
  UPDATE_ENTERPRISE_IN_PROGRESS,
  UPDATE_ENTERPRISE_SUCCESS,
  GET_ENTERPRISE_CERTIFICATES_IN_PROGRESS,
  GET_ENTERPRISE_CERTIFICATES_SUCCESS,
  GET_ENTERPRISE_CERTIFICATES_FAIL,
  DELETE_ENTERPRISE_CERTIFICATE_IN_PROGRESS,
  DELETE_ENTERPRISE_CERTIFICATE_SUCCESS,
  DELETE_ENTERPRISE_CERTIFICATE_FAIL,
} from "../constants";

/**
 * Update DO and CF logo
 */
export function updateEnterprise(uuid, logo) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ENTERPRISE_IN_PROGRESS });

    fetch("api").updateEnterprise(
      uuid,
      logo,
      () => {
        dispatch({ type: UPDATE_ENTERPRISE_SUCCESS });
      },
      (error) => {
        dispatch({
          type: UPDATE_ENTERPRISE_FAIL,
          payload: { violations: error.violations },
        });
      }
    );
  };
}

/**
 * Get enterprise logo
 */
export function getEnterpriseLogo(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_ENTERPRISE_LOGO_IN_PROGRESS });

    fetch("api").getEnterpriseLogo(
      uuid,
      (data) => {
        dispatch({
          type: GET_ENTERPRISE_LOGO_SUCCESS,
          payload: { logo: data },
        });
      },
      () => {
        dispatch({ type: GET_ENTERPRISE_LOGO_FAIL });
      }
    );
  };
}

/**
 * Get enterprise certificates
 */
export function getEnterpriseCertificates(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_ENTERPRISE_CERTIFICATES_IN_PROGRESS });

    fetch("api").getEnterpriseCertificates(
      uuid,
      (data) => {
        dispatch({
          type: GET_ENTERPRISE_CERTIFICATES_SUCCESS,
          payload: { certificates: data },
        });
      },
      (error) => {
        dispatch({
          type: GET_ENTERPRISE_CERTIFICATES_FAIL,
          payload: { violations: error.violations },
        });
      }
    );
  };
}

/**
 * Add enterprise certificate
 */
export function addEnterpriseCertificate(uuid, data, enterpriseUuid) {
  return (dispatch) => {
    dispatch({ type: GET_ENTERPRISE_CERTIFICATES_IN_PROGRESS });
    dispatch({ type: UPDATE_ENTERPRISE_IN_PROGRESS });

    fetch("api").addEnterpriseCertificate(
      uuid,
      data,
      () => {
        dispatch({ type: UPDATE_ENTERPRISE_SUCCESS });
        dispatch(getEnterpriseCertificates(enterpriseUuid));
      },
      (error) => {
        dispatch({
          type: UPDATE_ENTERPRISE_FAIL,
          payload: { violations: error.violations },
        });
        dispatch({
          type: GET_ENTERPRISE_CERTIFICATES_FAIL,
          payload: { violations: error.violations },
        });
      }
    );
  };
}

/**
 * Delete enterprise certificate
 */
export function deleteEnterpriseCertificate(uuid, enterpriseUuid) {
  return (dispatch) => {
    dispatch({ type: GET_ENTERPRISE_CERTIFICATES_IN_PROGRESS });
    dispatch({ type: DELETE_ENTERPRISE_CERTIFICATE_IN_PROGRESS });

    fetch("api").deleteEnterpriseCertificate(
      uuid,
      () => {
        dispatch({ type: DELETE_ENTERPRISE_CERTIFICATE_SUCCESS });
        dispatch(getEnterpriseCertificates(enterpriseUuid));
      },
      (error) => {
        dispatch({
          type: DELETE_ENTERPRISE_CERTIFICATE_FAIL,
          payload: { violations: error.violations },
        });
        dispatch({ type: GET_ENTERPRISE_CERTIFICATES_FAIL });
      }
    );
  };
}
